export default __webpack_public_path__ + "assets/images/aistudio/views/bcd111abdabde0d09c217354e42e62ca.png";